import styles from './tripThumbnail.css';

import aboutImage from './../../../pages/about.jpg';

function TripThumbnail({ trip, type }) {
  return (
    <div className="trip-thumbnail">
      <a href={`${type}/${trip.id}`}>
        <img src={aboutImage} className="trip-thumbnail-image" />
        <div className="trip-thumbnail-description">
          <div className="trip-thumbnail-title">{trip.title}</div>
          <div>{trip.duration}</div>
          <div>{trip.price} per person</div>
        </div>
      </a>
    </div>
  );
}

export default TripThumbnail;